(ns client-portal.client.products.google-cloud-projects.views
  (:require [client-portal.client.products.google-cloud-projects.data]
            [clojure.string :as s]
            [shared.core.amelia-light.components.components :as alc]
            [shared.core.reactive :as re]
            [shared.core.style :as style]))

(style/add-css [".google-cloud-projects-banner-change:focus-visible"
                {:outline (str "2px solid " (style/alc-color "Common/active" nil))
                 :outline-offset "2px"}])

(defn google-cloud-projects-banner
  "A strip across the top of the page naming each product on it whose data comes from an overridden Google Cloud
   project, one banner for all of them"
  [{:keys [padding]}]
  (let [overrides @(re/subscribe [:products/google-cloud-project-overrides-])
        accent (style/alc-color "Common/active")]
    (when (not-empty overrides)
      (let [phrases (map (fn [{:keys [label project-id]}]
                           [:span label " from "
                            [:span {:style {:font-weight 500}}
                             project-id]])
                         overrides)
            summary (str "Using "
                         (->> overrides
                              (map #(str (:label %) " from " (:project-id %)))
                              (s/join " and ")))]
        [:div {:role "status"
               :title summary
               :style {:align-items :center
                       :background-color (style/mix-color accent 8)
                       :border-bottom (str "1px solid " (style/mix-color accent 22))
                       :color (style/alc-color "Text/primary")
                       :display :flex
                       :flex "0 0 auto"
                       :font-size 13
                       :gap 8
                       :justify-content :center
                       :line-height "20px"
                       :min-height 32
                       :padding padding}}
         [alc/material-icon {:icon-type :cloud
                             :style {:color accent
                                     :display :block
                                     :flex "0 0 auto"
                                     :font-size 16
                                     :line-height 1}}]
         (into [:span {:style {:flex "0 1 auto"
                               :min-width 0
                               :overflow :hidden
                               :text-overflow :ellipsis
                               :white-space :nowrap}}
                "Using "]
               (interpose " and " phrases))
         [:button {:type "button"
                   :class-name "google-cloud-projects-banner-change"
                   :on-click #(re/dispatch [:products/open-google-cloud-projects])
                   :style {:background :none
                           :border :none
                           :border-radius 4
                           :color accent
                           :cursor :pointer
                           :flex "0 0 auto"
                           :font-size 13
                           :font-weight 500
                           :padding "2px 4px"}}
          "Change Projects"]]))))
